import { type FC, memo } from 'react';
import clsx from 'clsx';
import { useLayout } from '../../core';
import { KTSVG, toAbsoluteUrl } from '@helpers/index';
import { AsideMenu } from './menu/AsideMenu';
import { useSelector } from 'react-redux';
import { getCurrencyCodeSelector } from '@modules/subscriptions/core/selectors';
import { getCustomerSelector } from '@modules/customer/core/selectors';
import { useNavigate } from 'react-router-dom';
import { StoreCreditPfotenpunkteCard } from '@modules/store-credit/components/StoreCreditPfotenpunkteCard';

const AsideComponent: FC = () => {
  const { config, classes } = useLayout();
  const { aside } = config;
  const navigate = useNavigate();

  const customer = useSelector(getCustomerSelector);
  const currencySymbol = useSelector(getCurrencyCodeSelector);

  const storeCreditBalance = customer?.storeCredit?.total_balance ?? 0;
  const currencyCode = customer?.storeCredit?.currency_code ?? 'EUR';
  const isCHF = currencyCode === 'CHF' || currencySymbol === 'CHF';

  const formattedStoreCredit = isCHF
    ? `CHF ${storeCreditBalance}`
    : `${storeCreditBalance}${currencySymbol} `;

  const handlePrimaryCta = () => {
    if (isCHF) {
      window.location.href = 'https://www.hello-bello.ch/collections/store-credit';
    } else {
      window.location.href = 'https://www.hellobello.de/collections/store-credit';
    }
  };
  return (
    <div className="lg:sticky lg:top-[20px] lg:self-start">
      <div
        id="kt_aside"
        className={clsx(
          'aside card mr-[12px] aside-wrapper-card text-sm md:text-xl rounded-[30px]',
          classes.aside.join(' '),
          location.pathname === '/store-credit' ? 'shadow-pfotenpunkte' : 'shadow-oldShadow',
          {
            'd-none': !aside.display,
          },
        )}
        data-kt-drawer="true"
        data-kt-drawer-name="aside"
        data-kt-drawer-activate="{default: true, lg: false}"
        data-kt-drawer-overlay="true"
        data-kt-drawer-width="{default:'200px', '300px': '250px'}"
        data-kt-drawer-direction="start"
        data-kt-drawer-toggle="#kt_aside_mobile_toggle">
        <button className="svg-icon aside-close md:hidden" id="kt_aside_mobile_toggle">
          <KTSVG path="/media/svg/aside/close.svg" />
        </button>

        {/* begin::Aside menu */}
        <AsideMenu asideMenuCSSClasses={classes.asideMenu} />
        {/* end::Aside menu */}

        {/* begin::Footer */}
        {/* <div className='pt-5 aside-footer pb-7' id='kt_aside_footer'>

      </div> */}
        {/* end::Footer */}
      </div>
      <div className="mr-[12px] mt-[12px] hidden lg:block">
        <StoreCreditPfotenpunkteCard />
      </div>
    </div>
  );
};

export const Aside = memo(AsideComponent);
Aside.displayName = 'Aside';
